module.exports = __webpack_public_path__ + "f2cef35ee20e1bdcb3435621609e0ab6.jpg";